import React, { useState, useEffect } from "react";
import { Row, Col, Button, Spin } from "antd";
import AddPhysicianModalWrapper from "../../../modal/AddPhysicianModalWrapper";
import { CustomButton, CustomSecondaryButton } from "../styled";
import { MdDelete } from "react-icons/md";

const DeleteConfirmationModal = ({ isOpen, setOpen, onConfiem, loading, title, message }) => {
  const getDefaultMessage = () => {
    if (title?.includes("patient")) return "Are you sure you want to delete this patient?";
    if (title?.includes("scheduler") || title?.includes("assistant")) return "Are you sure you want to delete this scheduler?";
    if (title?.includes("video")) return "Are you sure you want to delete this video?";
    return "Are you sure you want to delete this?";
  };

  return (
    <>
      <AddPhysicianModalWrapper
        show={isOpen}
        setShow={setOpen}
        title={title || "Confirm Delete"}
        footer={null}
        width={400}
        keyClose={false}
      >
    {/* <Spin spinning={loading}> */}
        <Row className="d-flex justify-content-center mb-10">
          <div className="d-flex delete-modal-icon">
            <MdDelete style={{ fontSize: "30px", color: "#dc2626" }} />
          </div>
        </Row>
        <Row className="d-flex justify-content-center mb-5">
          <span className="font-20 font-semibold text-primary">
            {title || "Confirm Delete"}
          </span>
        </Row>

        <Row className="d-flex justify-content-center mb-15">
          <Col className="font-17 font-medium text-secondry">
            {message || getDefaultMessage()}
          </Col>
        </Row>
        <Row>
          <Col span={24} className="d-flex justify-content-center gap-12">
            <CustomSecondaryButton
              onClick={() => setOpen(false)}
              style={{ padding: "20px 50px" }}
            >
              Cancel
            </CustomSecondaryButton>
            <button
              className="d-flex justify-content-center custom-delete-button"
              onClick={onConfiem}
              loading={loading}
              disabled={loading}

            >
              {loading ? "Deleting..." : "Delete"}
              <Spin spinning={loading} />
            </button>
          </Col>
        </Row>
      {/* </Spin> */}
      </AddPhysicianModalWrapper>
    </>
  );
};

export default DeleteConfirmationModal;
